import { createRouter, createWebHistory } from 'vue-router';

import routeSectionAuth from './modules/auth.js'
import routeSectionServices from './modules/services.js'
import routeSectionPayments from './modules/payments.js'
import routeSectionSupport from './modules/support.js'
import routeSectionSettings from './modules/settings.js'
import routeSectionInformations from './modules/informations.js'
import routeSectionFiles from './modules/files.js'

import store from '@/store';

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: [
    { path: '/', redirect: '/services' },
    ...routeSectionAuth,            // /login, /forgot-password, /reset-password
    ...routeSectionServices,        // services/*
    ...routeSectionPayments,        // payments/*
    ...routeSectionSupport,         // support/*
    ...routeSectionSettings,        // settings/*
    ...routeSectionInformations,    // informations/*
    ...routeSectionFiles,           // files/*
    { path: '/:notFound(.*)', redirect: '/services' }
  ],
});

router.beforeEach(async function (to, _, next) {
  if (!to.meta.requiresAuth) {
    next();
    return;
  }
  // Con auth via session cookie httpOnly il frontend non può sapere "a sync" se è
  // autenticato: se lo store non lo è ancora, prova a stabilire la sessione (GET /user/user).
  if (!store.getters.isAuthenticated) {
    await store.dispatch('tryLogin');
  }
  next(store.getters.isAuthenticated ? undefined : '/login');
});

export default router;
